<script lang="ts">
    import { onMount } from 'svelte';
    import { get } from 'svelte/store';

    import type { ImportResponseType } from '../../shared/ColumnSelectPro/currentImport';
    import { ImportApi } from './ImportApi';
    import { api } from '../../../stores/api';

    export let _import: ImportResponseType;
    export let inProgress: string = '';
    export let onDone: string = '';

    let progress: number = 0;
    let error: string = '';
    let handler: any;
    let lastProgress: number = 0;
    let currentMiliseconds: number = 4000;

    function forceReload() {
        if (handler) clearTimeout(handler);
        if (_import) {
            ImportApi.getStatus(get(api), _import.id)
                .then(response => {
                    progress = response.percent;
                    if (progress >= 100) {
                        if (_import) {
                            ImportApi.getOne(get(api), _import.id).then(response => {
                                _import = response;
                            });
                        }
                    } else {
                        if (Math.round(progress) === Math.round(lastProgress)) {
                            currentMiliseconds = Math.min(currentMiliseconds * 1.5, 30000);
                        } else {
                            currentMiliseconds =
                                currentMiliseconds / 2 +
                                Math.floor(Math.random() * currentMiliseconds);
                        }
                        handler = setTimeout(forceReload, currentMiliseconds);
                    }
                })
                .catch(err => {
                    error = '[error]';
                    if (handler) clearTimeout(handler);
                });
        } else {
            error = '[empty]';
        }
    }

    onMount(() => {
        handler = setTimeout(
            forceReload,
            currentMiliseconds + Math.floor((Math.random() * currentMiliseconds) / 2)
        );
        return () => {
            if (handler) clearTimeout(handler);
        };
    });
</script>

<div>
    {#if error}
        {error}
    {:else if progress >= 100}
        {onDone}
    {:else}
        {inProgress}&nbsp;{progress}%
    {/if}
</div>
